import { STORE_LIVE_PARKING_AVAILABILITIES } from "./liveParkingAvailabilitiesReducer"

export const storeLiveParkingsAvailabilities = (data) => ({
    type: STORE_LIVE_PARKING_AVAILABILITIES,
    payload: data
})